import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useSatisfacaoClientePesquisaListaFilters
 */

type State = {
  respondidaPor: string | null;
  data: Date | null;
  local: string | null;
  status: number;
};

type Actions = {};

export const useSatisfacaoClientePesquisaListaFilters = create<State & Actions>((set) => ({
  respondidaPor: null,
  data: null,
  local: null,
  status: 2,
}));

/**
 * initialSatisfacaoClientePesquisaListaState
 */

export const initialSatisfacaoClientePesquisaListaState: State = {
  respondidaPor: null,
  data: null,
  local: null,
  status: 2,
};